import type { AxiosError } from 'axios';
import { ShareErrorCode } from '../types';

interface ParsedShareError {
  status: number | null;
  code: ShareErrorCode;
  message: string;
}

interface ServerErrorBody {
  statusCode?: number;
  message?: string | { message?: string; code?: string };
  code?: string;
}

const isShareErrorCode = (value: unknown): value is ShareErrorCode =>
  typeof value === 'string' &&
  Object.values(ShareErrorCode).includes(value as ShareErrorCode);

export function parseShareError(error: unknown): ParsedShareError {
  const axiosError = error as AxiosError<ServerErrorBody> | undefined;
  const status = axiosError?.response?.status ?? null;
  const data = axiosError?.response?.data;

  let rawMessage: unknown = data?.message;
  let rawCode: unknown = data?.code;

  if (rawMessage && typeof rawMessage === 'object') {
    rawCode = rawCode ?? (rawMessage as { code?: string }).code;
    rawMessage = (rawMessage as { message?: string }).message;
  }

  const code = isShareErrorCode(rawCode) ? rawCode : ShareErrorCode.UNKNOWN;
  const message = typeof rawMessage === 'string' ? rawMessage : '';

  return { status, code, message };
}
